import { Component, OnInit } from '@angular/core';

import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-select-media-modal',
  templateUrl: './select-media-modal.component.html',
  styleUrls: ['./select-media-modal.component.scss']
})
export class SelectMediaModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SelectMediaModalComponent>) { }

  ngOnInit() {
  }

  imageSelected(image) {
    this.dialogRef.close(image);
  }
}
